export const enum PaxSelectorEventType {
  AdultIncrease = 'adultIncrease',
  AdultDecrease = 'adultDecrease',
  ChildIncrease = 'childIncrease',
  ChildDecrease = 'childDecrease',
  UpdateChildAge = 'updateChildAge',
  RemoveRoom = 'removeRoom',
  AddRoom = 'addRoom',
}

export interface PaxAmountChangeEvent {
  eventType:
    | PaxSelectorEventType.AdultIncrease
    | PaxSelectorEventType.AdultDecrease
    | PaxSelectorEventType.ChildIncrease
    | PaxSelectorEventType.ChildDecrease;
  roomIndex: number;
}

export interface RemoveRoomEvent {
  eventType: PaxSelectorEventType.RemoveRoom;
  roomIndex: number;
}

export interface AddRoomEvent {
  eventType: PaxSelectorEventType.AddRoom;
}

export interface ChildAgeChangeEvent {
  eventType: PaxSelectorEventType.UpdateChildAge;
  roomIndex: number;
  childIndex: number;
  age: number;
}

export type PaxSelectorEvents =
  | PaxAmountChangeEvent
  | ChildAgeChangeEvent
  | RemoveRoomEvent
  | AddRoomEvent;

export interface RoomPaxConfig {
  amountOfAdults: number;
  amountOfChildren: number;
  childAges: number[];
}

export interface ConfigurationPanelPaxDetails {
  title?: string;
  initialPaxes: RoomPaxConfig[];
  shouldShowTicketsWarning: boolean;
  shouldShowRoomSelectionWarning: boolean;
  shouldShowNumberOfVehiclesUpdatedWarning: boolean;
}

export interface RoomPaxConfigWithId extends RoomPaxConfig {
  uniqueId: string;
}
